import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

		this.$video = this.$('video')[0];
		this.noVideo = false;

		if(this.$video == undefined) {
			this.noVideo = true;
		}

		if(!window.isMobile) {
			this.events = {
				'mouseenter': {
					inner: 'hover'
				},
				'mouseleave': {
					inner: 'leave'
				}
			}
		}

		this.videoIsLoaded = false;
    }

    init() {

    }

	hover() {
		if(window.isMobile || this.noVideo) return;

		this.$video.play();
		this.$video.classList.add('is-visible');

	}

	load() {
		this.$video.setAttribute('src',this.$video.getAttribute('data-src'));
		this.videoIsLoaded = true;
	}

	leave() {
		if(window.isMobile || this.noVideo) return;

		this.$video.pause();
	}

	destroy() {
		if(this.bindLoad != undefined) {
			this.$video.removeEventListener('canplay', this.bindLoad)
		}
	}
	
}
